import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api_routes } from '@app/consts';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { EnvironmentService } from '@app/core/services/environment.service';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { ToilBalanceRecord } from '../models/toil-balance-report.model';


const headers = new HttpHeaders({
    'Content-Type': 'application/json',
});

@Injectable({
    providedIn: 'root'
})
export class ToilBalanceReportService {

    constructor(
        private http: HttpClient,
        private translate: TranslateService,
        private overlayService: OverlayService,
        private datePipe: DatePipe,
        private envService: EnvironmentService
    ) {}

    async getAllToilBalanceReportData(filter?: string, sort?: string, asOf?: string, filterInactiveEmployees?: boolean): Promise<PagedData<ToilBalanceRecord>> {
        let take = 100;
        let skip = 0;
        let allData = {
            skip: null,
            take: null,
            totalPages: null,
            total: null,
            data: []
        }

        while (allData.total === null || skip < allData.total) {
            const res = await this.getToilBalanceReportData(take, skip, filter, sort, asOf, filterInactiveEmployees).toPromise();

            if (res && res.data && res.data.length > 0) {
                allData.data = allData.data.concat(res.data);
                skip += take;
                allData.total = res.total;
            } else {
                break;
            }
        }

        return allData;
    }

    getToilBalanceReportData(take?: number, skip?: number, filter?: string, sort?: string, asOf?: string, filterInactiveEmployees?: boolean): Observable<PagedData<ToilBalanceRecord>> {
        let params = new HttpParams();
        take ? params = params.append('take', take) : null;
        skip ? params = params.append('skip', skip) : null;
        filter ? params = params.append('filter', filter) : null;
        sort ? params = params.append('sort', sort) : null;
        asOf ? params = params.append('asOf', asOf) : null;
        filterInactiveEmployees ? params = params.append('filterInactiveEmployees', filterInactiveEmployees) : null;

        return this.http
            .get<any>(`${this.envService.env.apiUrl}${api_routes.REPORTS}/${api_routes.PREDEFINED}/${api_routes.TOIL_BALANCE_REPORT}`, {
                headers: headers,
                params: params
            })
    }

}
